/**
 * This function will sort the current user as first and alphabetically the other users
 *
 * Example of sorted names order with current user "Jack Daniels":
 * Jack Daniels
 * Avi
 * Former member
 * simha-rotman@gmail.com
 * Tomer
 * Zach
 */
import { useMemo } from 'react';
import { useUser } from '@adsk/alloy-provider';
import { useOxygen } from '../../../providers/OxygenProvider';
import { Assignee } from '../../../sdk';
import { sortAssigneesWithCurrentUserFirst } from '../../../helpers/assigned-to-helpers';
import { EMPTY_ARRAY } from '../../../constants';

export const useSortAssignees = (assignees: Assignee[] = EMPTY_ARRAY, isTargetRfi = false) => {
  const { user: currentUser } = useUser();
  const oxygen = useOxygen();

  return useMemo(
    () => sortAssigneesWithCurrentUserFirst({ assignees, oxygen, currentUser, isTargetRfi }),
    [assignees, oxygen, currentUser],
  );
};
